<template>
  <products-item-form />
</template>

<script>

import ProductsItemForm from '@/views/Products/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    ProductsItemForm,
  },
}
</script>
